<template lang="jade">
  div.Notice(v-show="notice.show"
             v-bind:class="state")
    i.Notice__icon(v-bind:class="icon")
    div.Notice__text {{ notice.msg[0] | customMessage }}
    div.Notice__close(@click="close(notice)")
</template>

<script>
import { removeNotification } from 'src/vuex/actions'
import errorMessages from 'src/config/errors'

export default {
  data: () => ({}),

  props: { icon: { type: Array,
                   required: true },
           state: { type: Array,
                    required: true },
           notice: { type: Object,
                     required: true } },

  vuex: { actions: { removeNotification } },

  ready () {
    setTimeout(this.close, this.notice.timeout)
  },

  filters: {
    customMessage (msg) {
      if (errorMessages[msg] !== undefined) {
        return errorMessages[msg]
      }
      return msg
    }
  },

  methods: {
    remove (id) {
      this.removeNotification(id)
    },

    close () {
      let { onComplete, id } = this.notice
      if (onComplete) this[onComplete](id)
      this.$set('notice.show', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// notice.vue?9233f7d0